import { useCallback, useMemo } from 'react';
import UISideNavItem from 'UIComponents/nav/UISideNavItem';
import UITruncateString from 'UIComponents/text/UITruncateString';
import UIScreenReaderOnly from 'UIComponents/text/UIScreenReaderOnly';
import UniversalAssociationsSelectSideNavAccessibilityMessage from './UniversalAssociationsSelectSideNavAccessibilityMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UniversalAssociationsSelectSideNavItem = ({
  association,
  onSetSelectedObjectTypeId,
  selectedObjectTypeId
}) => {
  const pluralObjectName = association.get('pluralObjectName');
  const selectedCount = useMemo(() => {
    return association.get('associationOptionRecords').filter(associationOptionRecord => associationOptionRecord.get('isSelected')).size;
  }, [association]);
  const handleSelectNavItem = useCallback(() => {
    const newSelectedObjectTypeId = association.get('toObjectTypeId');
    if (selectedObjectTypeId === newSelectedObjectTypeId) {
      return null;
    }
    return onSetSelectedObjectTypeId(association.get('toObjectTypeId'));
  }, [association, onSetSelectedObjectTypeId, selectedObjectTypeId]);
  const isActive = useMemo(() => {
    return selectedObjectTypeId === association.get('toObjectTypeId');
  }, [association, selectedObjectTypeId]);
  const uniqueIdentifier = association.get('associationTypeId');
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(UISideNavItem, {
      "data-test-id": `universal-associations-select-nav-item-${uniqueIdentifier}`,
      "data-selenium-test": "association-nav",
      "data-selenium-value": pluralObjectName,
      "aria-describedby": `universal-associations-select-nav-item-${uniqueIdentifier}`,
      title: /*#__PURE__*/_jsx(UITruncateString, {
        children: pluralObjectName
      }),
      active: isActive,
      count: selectedCount,
      onClick: handleSelectNavItem
    }), /*#__PURE__*/_jsx(UIScreenReaderOnly, {
      children: /*#__PURE__*/_jsx("div", {
        id: `universal-associations-select-nav-item-${uniqueIdentifier}`,
        children: /*#__PURE__*/_jsx(UniversalAssociationsSelectSideNavAccessibilityMessage, {
          pluralObjectName: pluralObjectName,
          count: selectedCount
        })
      })
    })]
  });
};
export default UniversalAssociationsSelectSideNavItem;